export const GAME_REFERRAL_SHARE_BASE = "https://app.daksby.by/game"

/** Публичный паспорт на сайте комикса / guardians */
export const GUARDIANS_PUBLIC_PROFILE_BASE =
  "https://guardians.daks.by/guardians/player"

export const DAKSBY_STORE_LINKS = {
  android: {
    label: "Android",
    href: "https://play.google.com/store/apps/details?id=com.atedevby.gdaksby&hl=ru",
  },
  ios: {
    label: "iOS",
    href: "https://apps.apple.com/ru/app/%D1%85%D1%80%D0%B0%D0%BD%D0%B8%D1%82%D0%B5%D0%BB%D0%B8-daksby/id6783672059",
  },
} as const

export function buildGameReferralShareUrl(publicGameCode: string): string {
  const code = String(publicGameCode ?? "").trim()
  return `${GAME_REFERRAL_SHARE_BASE}?ref=${encodeURIComponent(code)}`
}

export function buildGuardiansPublicProfileUrl(publicGameCode: string): string {
  const code = String(publicGameCode ?? "").trim()
  return `${GUARDIANS_PUBLIC_PROFILE_BASE}/${encodeURIComponent(code)}`
}

export function buildGameReferralShareMessage(publicGameCode: string): string {
  const code = String(publicGameCode ?? "").trim()
  const { android, ios } = DAKSBY_STORE_LINKS
  const profileUrl = buildGuardiansPublicProfileUrl(code)

  return (
    "Присоединяйся к «Хранителям» в DAKSBY!\n" +
    `Код друга: ${code}\n` +
    `Профиль друга: ${profileUrl}\n\n` +
    "Скачай приложение:\n" +
    `${ios.label}: ${ios.href}\n` +
    `${android.label}: ${android.href}`
  )
}

/** Из deep link или веб-URL вида …/game?ref=ХРАНИТЕЛЬ-4821 */
export function parseGameReferrerFromUrl(url: string): string | null {
  const raw = String(url ?? "").trim()
  if (!raw) return null

  try {
    const parsed = new URL(raw)
    const ref = parsed.searchParams.get("ref")
    if (ref?.trim()) return ref.trim()
    const pathMatch = parsed.pathname.match(/\/game\/?$/i)
    if (pathMatch && ref?.trim()) return ref.trim()
  } catch {
    const queryMatch = raw.match(/[?&]ref=([^&#]+)/i)
    if (queryMatch?.[1]) {
      try {
        return decodeURIComponent(queryMatch[1]).trim()
      } catch {
        return queryMatch[1].trim()
      }
    }
  }

  return null
}
